<template>
    <div class="start-container">
        <div class="logo">
            <img :src="logo">
        </div>
        <div class="title">
            <p>非遗数字化与多源信息融合</p>
            <p style="font-size: 20px;">福建省高校工程研究中心</p>
        </div>
        <div class="btn-start" @mouseover="btnHover = true" @mouseout="btnHover = false"
             @click="start">
            <div class="left-text" :class="{'left-text-hover':btnHover}">点击开启非遗图谱</div>
        </div>
        <div class="stat">
            <counter v-for="item in baseConfig.stat_count" :count="item.count" :title="item.title"></counter>
        </div>
        <div class="copyright">
            CopyRight &copy2020 非遗数字化与多源信息融合福建省高校工程研究中心 版权所有 | 闽ICP备20010969号-1
        </div>
    </div>
</template>

<script>
    import logo from "@/assets/logo.png";
    import counter from "@/components/counter";
    import {mapGetters} from 'vuex'

    export default {
        name: "start",
        components: {
            counter
        },
        data() {
            return {
                btnHover: false,
                logo: logo,
                statInfo: []
            }
        },
        methods: {
            start: function () {
                this.$store.commit('componentsSwitch', {name: 'btnStart', status: false});
                this.$store.commit('componentsSwitch', {name: 'intro', status: true});
                this.$store.commit('bgBlurSwitch', true);
                setTimeout(() => {
                    this.$store.commit('componentsSwitch', {name: 'recommend', status: true});
                }, 1000);
                setTimeout(() => {
                    this.$store.commit('componentsSwitch', {name: 'map', status: true});
                }, 500);
            }
        },
        computed: {
            ...mapGetters([
                'baseConfig'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .start-container {
        margin: 5vh auto 0 auto;
        .title {
            font-size: 30px;
            color: #fff;
            font-weight: bold;
            text-align: center;
            p {
                margin-bottom: 0;
            }
        }
        .logo {
            margin: auto;
            width: 150px;
            height: 150px;
            line-height: 100px;
            text-align: center;
            border-radius: 100px;
            margin-bottom: 20px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .btn-start {
            margin: auto;
            background: #fff;
            height: 45px;
            line-height: 45px;
            width: 200px;
            margin-top: 5vh;
            padding: 0 10px 0 15px;
            display: flex;
            color: #333;
            border-radius: 50px;
            cursor: pointer;
            text-align: center;
            .left-text {
                font-size: 16px;
                flex-grow: 1;
                transition: all ease .3s;
            }
            .left-text-hover {
                font-weight: bold;
                color: #ffa328;
                font-size: 17px;
            }
            .right-btn {
                width: 80px;
                height: 35px;
                background: #444;
                margin-top: 5px;
                border-radius: 5px;
                transition: all ease .3s;
                text-align: center;
                color: #fff;
                line-height: 35px;
            }
            .right-btn-hover {
                width: 70px;
            }
        }
        .stat {
            width: 100%;
            text-align: center;
            margin-top: 5vh;
            .number-container {
                display: inline-block;
                width: 100px;
                color: #fff;
                .number {
                    font-size: 30px;
                }
                .text {
                    font-size: 14px;
                }
            }
        }
        .copyright {
            text-align: center;
            color: #fff;
            margin-top: 10vh;
            font-size: 13px;
        }
    }
</style>